export const PubSubConstants = {
  WebApiHost:      'https://password-api-local.servicecatalog.aws.boisestate.edu/',
  UserRole:        'AWS-BLABLABLA Admins',
  AdminRole:       'wp-super',
  AdminPathPrefix: '/password-reset/admin',
  AdminHashPrefix: '/#/password-reset/admin',
  UserPathPrefix:  '/password-reset/user',
  UserHashPrefix:  '/#/password-reset/user',
};